import React from "react";
import styles from "./OrgMissingMessage.module.scss";
import { FaExclamationTriangle } from "react-icons/fa";
import { Button } from "@whatslly/ui-components/v2/Button";
import { Link } from "react-router-dom";

export const OrgMissingMessage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.message}>
        <FaExclamationTriangle />
        <h1>Organization does not exist</h1>
        <p>The organization you are trying to access does not exist.</p>
        <Link to="/">
          <Button>Go to Home</Button>
        </Link>
      </div>
    </div>
  );
};
